import { Pipe, PipeTransform } from '@angular/core';
import { UtilitiesService } from 'src/app/core/utilities.service';

@Pipe({
  name: 'translate',
  pure: false,
})
export class TranslationPipe implements PipeTransform {
  constructor(private utils: UtilitiesService) {}

  transform(str: string, values: any) {
    return this.utils.translate(str, values);
  }
}
